// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import Action from 'core/fsmpack/statemachine/actions/Action';

/**
 * @autodoc apply FsmAction
 */
class RemoveParticlesAction extends Action {
  enter(fsm) {
    // TODO: Deprecate one of two duplicate particle systems https://sim.amazon.com/issues/SUMERIAN-8270
    this._entity = fsm.getOwnerEntity();
    if (this._entity.hasComponent('ParticleSystemComponent')) {
      this._entity.clearComponent('ParticleSystemComponent');
    }

    this._removeChildrenWithName('_ParticleSystemFire');
    this._removeChildrenWithName('_ParticleSystemSmoke');
  }

  _removeChildrenWithName(name) {
    const children = this._entity.publicEntity.children.withName(name);
    children.forEach((child) => {
      child.removeFromWorld();
    });
  }
}

RemoveParticlesAction.external = {
  key: 'RemoveParticles',
  deprecatedKey: 'Remove Particles',
  name: 'Remove Particles',
  type: 'fx',
  description: 'Removes any particle emitter attached to the entity.',
  parameters: [],
  transitions: [],
};

RemoveParticlesAction.register();

export default RemoveParticlesAction;
